export default __webpack_public_path__ + "static/media/offset-white-card-stack-icon.a2e99815.svg";